/*
* class AppFunctions
*/

var AppFunctions = function() {

    /*
    * Env variables
    */

    let state = 0;

    /*
    * front
    */

    var controlResp = function()
    {
        // Exemple actions pour responsive
        // let togglemenu = document.getElementById('toggle_menu')
        // let menublock  = document.getElementById('resp_menu')
        // let holdmenu   = document.getElementById('hold_resp_menu')

        // var trait = function(event){
        //     var res = ['m','sm','s'];
        //     if( !res.includes(PAtools.getScreenType()) )
        //         return;
         
        //     event.preventDefault()

        //     if( menublock.classList.contains('open') ){
        //         menublock.classList.remove('open')
        //         document.body.classList.remove('overled')
        //     }
        //     else{
        //         menublock.classList.add('open')
        //         document.body.classList.add('overled')
        //     }
        // }

        // menublock.addEventListener('touchstart', trait)
        // menublock.addEventListener('click', trait)

        // holdmenu.addEventListener('click', function(event){
        //     event.stopPropagation()
        // })
        // holdmenu.addEventListener('touchstart', function(event){
        //     event.stopPropagation()
        // })
    }

    var controlNav = function()
    {
        // window.onpopstate = function(){
            
        // }
        window.addEventListener("popstate", function(e) {

            // URL location
            var location = document.location;
        
            // state
            var state = e.state;
            
            // return to last state
            if(e.state.id){

                loadProjet(e.state.id, true);
            }
            else{
                let currentprojet = document.getElementById('projet_container');
                doClose(currentprojet)
            }
        });
    }

    var controlScroll = function(projet)
    {
        var projet = projet || document.getElementById('projet_container');
        // console.log('o');
        if(projet){

            var next = projet.querySelector('.next-projet');
    
            next.addEventListener('click', function(event){
                event.preventDefault();
                loadProjet(projet.firstElementChild.dataset.next)
            })
        }
        
        // projet.onscroll = function(e) {
        //     console.log('scroll');
            
        //     let scrollh = projet.scrollHeight;
        //     let scroll  = projet.scrollTop;
        //     let windowh = window.innerHeight;

        //     if( (scroll+windowh) >= scrollh ) {
        //         loadProjet(projet.firstElementChild.dataset.next)
        //     }
        // };
    }

    var loadProjet = function(id, dontpop) 
    {
        var dontpop       = dontpop || false;
        let currentprojet = document.getElementById('projet_container');

        if(currentprojet){
            doClose(currentprojet);
        }
        
        let request = new Promise(function (resolve, reject) {
                
            let xhr = new XMLHttpRequest();
            
            xhr.open('GET', '/ajax/loadprojet?id='+id, true);
            xhr.responseType = 'json';
            xhr.onload = function () {
                if (this.status >= 200 && this.status < 300) {
                    resolve(xhr.response);
                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            };

            xhr.send();
        });

        /**
         * Trait request
         */

        request.then(function (response) {

            state++;

            let objstate = { 
                'state': state,
                'id': response.ID
            }
            
            if(!dontpop){
                history.pushState(objstate, response.title, response.link)
            }
            
            /**
             * Replace src images
             */

            let m;
            let html  = response.html;
            let regex = /src="(.+?)"/gm;

            while ( (m = regex.exec(response.html) ) !== null) {
                // console.log(m);
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }
      
                html = html.replace(m[0], 'data-src="'+m[1]+'" src="'+pa.templateurl+'/images/image_default.gif"' );
            }

            html = html.replaceAll('srcset','srcset_');

            /**
             * Append html
             */
            
            let projet = document.createElement('aside');

            projet.id = 'projet_container';
            projet.innerHTML = html;
            projet.classList.add('open');
            
            document.body.classList.add('overled');
            document.body.appendChild(projet);
            
            closeProjet(projet);
            controlScroll(projet);

            /**
             * Load images
             */

            let images = projet.querySelectorAll('img');
            let count  = 0;
            // console.log(images.length);
            
            [].forEach.call(images, function(img){
                
                if(!img.dataset.src)
                    return;

                let downloadingImage = new Image();
                downloadingImage.onload = function(){
                    img.src = this.src;   
                    count++;
                };
                downloadingImage.src = img.dataset.src;
            });
            
            ga('send', 'pageview', location.pathname);

        }).catch(function (err) {
            console.error('Error', err);
        });
    }

    var closeProjet = function(projet) 
    {
        projet = projet || document.getElementById('projet_container');
        // let projet = document.getElementById('projet_container');
        if(projet){

            let holder = projet.querySelector('.holder');
            let btnclose = projet.querySelector('.close-projet');

            btnclose.addEventListener('click', function(){
                
                let state = { 
                    title: '',
                    link: '/',
                }
                history.pushState(state, '', '/')
                doClose(projet)
            })
            projet.addEventListener('click', function(){

                let state = {
                    title: '',
                    link: '/',
                }
                history.pushState(state, '', '/')
                doClose(projet)
            })
            holder.addEventListener('click', function(event){
                event.stopPropagation();
            })
        }
    }

    var doClose = function(projet)
    {
        projet.classList.add('close');
        document.body.classList.remove('overled');
        setTimeout(function(){
            // projet.classList.remove('open');
            projet.remove();
        },300);
    }
    

    return {

        /*
        * Main class initializer
        */

        init: function() {
            AppFunctions.initComponents();

            while (pagefunctions.length){
                pagefunctions.shift().call();
            }
        
            if(typeof launchFunction == 'function')
                launchFunction()
        },

        /*
        * Initializes components
        */

        initComponents: function() {
            
            // controlOverlay()
            
            controlResp()
            controlNav()
            // controlForm()
            // controlSlides()

            // loadOverlay({'overlay':'contactform'})

            // $(window).resize(function() {
                // controlResp()
            // })
        },

        closeProjet: function() {
            closeProjet()
        },
        
        controlScroll: function() {
            controlScroll()
        },

        loadProjet: function(id, dontpop) {
            loadProjet(id, dontpop)
        },

        initForm: function(id) {

            return ajaxForm(id)
        }
    };

}();

(function() {

    // AppFunctions.init();    

})();